module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/6ZUfFwH5odeEIabFOGpeuq-10bf7b85c849a4683d455840d3bd9f7d.jpg";